// update state
const setStateDefaultRole = (payload) => {
    return {
        type: "DEFAULTROLEID",
        payload
    }
}

export default setStateDefaultRole;


// WEBPACK FOOTER //
// ./src/actions/setStateDefaultRoleID.js